(ns leg.main
  "Entry point. One screen: the reader, or the way in when there is no key
  yet.

  The sign-in screen is drawn inside the same theme as everything else - it
  is the first thing anybody sees, and there is no reason for it to be the
  one screen that looks like something different."
  (:require-macros [kc.core :refer [def-ui $]])
  (:require ["react-dom/client" :as rdom]
            [kc.core :as kc]
            [leg.app :as app]
            [leg.auth :as auth]
            [leg.login :as login]
            [leg.mui :as mui]
            [leg.pwa :as pwa]
            [leg.state :as state]
            [leg.theme :as theme]))

(def-ui Root []
  (let [{:keys [needed?]} (kc/use-atom auth/!auth)
        st      (state/use-state)
        signed? (and (not needed?) (some? (auth/token)))
        mode    (theme/use-mode (get-in st [:settings :reader/theme]))
        face    (get-in st [:settings :reader/font])]
    ;; The palette is a prop and the face is an attribute on `<html>`, which
    ;; is the difference between something components draw and something CSS
    ;; reads - the article's body is markup and no component sees it (see
    ;; `leg.theme/set-face!`).
    (kc/use-effect [face] (theme/set-face! face))
    ($ mui/Frame {:mode mode}
       (if signed?
         ($ app/App {:state st})
         ($ login/Login)))))

(defonce ROOT
  (delay
    (let [element (js/document.getElementById "root")]
      (kc/assert element ::root-element-missing)
      (rdom/createRoot element))))

(defn render! []
  (-> @ROOT (.render ($ Root))))

(defn after-load! [] (render!))

(defn main! []
  (theme/install!)
  (pwa/install!)
  ;; Before anything is drawn, because it is one listener on the document
  ;; and not something a component owns: links out of here lead out of the
  ;; installed app as well.
  (pwa/install-links!)
  ;; The address first: it says which feed and which article this window was
  ;; opened on, and `load-state!` asks the server for that list rather than
  ;; for the default one and then correcting itself.
  (state/install-routing!)
  ;; Asked for at once, and only when this window has a key - a window that
  ;; has to sign in first would otherwise spend its first request being
  ;; refused. `start!` and not `load-state!`: this is the one fetch after
  ;; which the window may still be put somewhere (`leg.state/start-pane!`).
  (when (auth/token) (state/start!))
  (render!))
